// extracted by mini-css-extract-plugin
export var active = "_gj-2";
export var recordingDot = "_gj-1";
export var recordingIndicator = "_gj-0";